/**
 * Extracts displayable error strings from TanStack Form field errors.
 *
 * Standard Schema validators (Zod) return objects with a `message` property.
 */
export function formatFieldErrors(errors: unknown[]): string[] {
  return errors.map((error) => String((error as { message: string }).message))
}
